import Model from '@/app/Model'
import { User } from '@/models/User'

export class DepartmentVacation extends Model {
	static fields () {
		return {
			id: null,
			departmentId: null,
			dateFrom: null,
			dateTo: null,
			status: null,
			channels: [],
			endedEarlyAt: null,
			completedAt: null,
			createdBy: User,
			summary: {}
		}
	}

	static hasMany () {
		return {}
	}
}

export function createDepartmentVacation (data) {
	return Object.freeze(new DepartmentVacation(data))
}
